import { action, observable } from 'mobx'
import type { $RootStore } from './RootStore'

export type EditTextModalType = 'text' | 'integer' | 'number' | 'currency' | 'url' | 'email' | 'mobile'

export type EditTextModalShowOptions = {
  key: string
  value?: string | number
  type?: EditTextModalType
  prefix?: string
  placeholder?: string
  onChange?: (key: string, value: string | number | undefined) => void
  onBackdropPress?: () => void
  validation?: (value: string) => boolean
}

export interface EditTextModalData {
  open: boolean
  key: string
  value?: string | number
  type?: EditTextModalType
  prefix?: string
  placeholder?: string
  error?: string
  onChange?: (key: string, value: string | number | undefined) => void
  onBackdropPress?: () => void
}

const editTextModalDefaultData: EditTextModalData = {
  open: false,
  key: '',
  value: '',
  type: 'text',
  prefix: '',
  error: undefined,
}

// this class is a stubbed class to accommodate the use of the EditTextModalController in the shared-solo repo

class EditTextModalController {
  rootStore: $RootStore

  @observable accessor editTextModalData: EditTextModalData = editTextModalDefaultData

  constructor(rootStore: $RootStore) {
    this.rootStore = rootStore
  }

  @action show = (_opts: EditTextModalShowOptions) => {
    const { key, value, type, prefix, onChange, onBackdropPress, placeholder } = _opts
    this.editTextModalData.open = true
    this.editTextModalData.key = key
    this.editTextModalData.value = value
    this.editTextModalData.type = type
    this.editTextModalData.prefix = prefix
    this.editTextModalData.placeholder = placeholder
    this.editTextModalData.error = undefined
    this.editTextModalData.onChange = onChange
    this.editTextModalData.onBackdropPress = onBackdropPress
  }

  @action hide = () => {
    this.editTextModalData = { ...editTextModalDefaultData }
  }

  @action setError = (message?: string) => {
    this.editTextModalData.error = message
  }
}

export default EditTextModalController
